module.exports = __webpack_public_path__ + "static/media/timeslot.ea69e2c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/candidate/assets/timeslot.svg
// module id = 1642
// module chunks = 0